const locales = {
  c4r: {
    form: {
      selectAll: 'Todos',
      selectNone: 'Ninguno',
      allSelected: 'Todos seleccionados',
      noneSelected: 'Ninguno seleccionado',
      selected: 'seleccionado'
    },
    widgets: {
      category: {
        apply: 'Aplicar',
        unlock: 'Desbloquear',
        lock: 'Bloquear',
        clear: 'Limpiar',
        noResults: 'Sin resultados',
        noResultsMessage: 'Su búsqueda "{searchValue}" no coincide con ningún valor.',
        cancel: 'Cancelar',
        searchInfo: 'Buscar en {elements} elementos',
        selectedItems: '{items, plural, one {# seleccionado} other {# seleccionados}}',
        all: 'Todos',
        search: 'Buscar'
      },
      bar: {
        all: 'Todos',
        selectedItems: '{items, plural, one {# seleccionado} other {# seleccionados}}',
        clear: 'Limpiar'
      },
      histogram: {
        all: 'Todos',
        selectedItems: '{items} seleccionados',
        clear: 'Limpiar'
      },
      legend: {
        layerOptions: 'Opciones de capa',
        hide: 'Ocultar',
        show: 'Mostrar',
        layer: 'capa',
        opacity: 'Opacidad',
        hideLayer: 'Ocultar capa',
        showLayer: 'Mostrar capa',
        open: 'Abrir leyenda',
        close: 'Cerrar',
        collapse: 'Colapsar capa',
        expand: 'Expandir capa',
        zoomLevel: 'Nivel de zoom',
        zoomLevelTooltip: 'Esta capa solo es visible a ciertos niveles de zoom',
        lowerThan: 'menor que',
        greaterThan: 'mayor que',
        and: 'y',
        zoomNote: 'Nota: esta capa se mostrará a un nivel de zoom',
        notSupported: 'no es un tipo de leyenda conocido',
        subtitles: {
          proportion: 'Tamaño basado en',
          icon: 'Icono basado en',
          strokeColor: 'Color del borde basado en',
          color: 'Color basado en'
        },
        max: 'Max',
        min: 'Min'
      },
      range: {
        clear: 'Limpiar',
        minLimit: 'Límite mínimo',
        maxLimit: 'Límite máximo',
        minValue: 'Valor mínimo',
        maxValue: 'Valor máximo'
      },
      table: {
        rowsPerPage: 'Filas por página',
        of: '{from}–{to} de {count}',
        moreThan: 'más de'
      },
      timeSeries: {
        speed: 'Velocidad',
        clear: 'Limpiar'
      },
      featureSelection: {
        drawPolygonMode: 'Polígono',
        drawRectangleMode: 'Rectángulo',
        drawPolygonByDraggingMode: 'Herramienta Lazo',
        drawCircleFromCenterMode: 'Círculo',
        edit: 'Editar máscara',
        clickToEdit: 'Haga clic en la máscara para editarla',
        clickToCreate: 'Haga clic en el mapa para crear una máscara',
        selectTool: 'Seleccionar un {label}',
        selectMode: 'Seleccionar un modo',
        chooseSelectionMode: 'Elegir un modo de selección',
        applyMask: 'Aplicar máscara',
        clearMask: 'Limpiar máscara',
        remove: 'Eliminar',
        polygon: 'Polígono',
        point: 'Punto',
        lineString: 'Línea'
      },
      pie: {
        clear: 'Limpiar',
        selectedItems: '{items, plural, one {# seleccionado} other {# seleccionados}}',
        allSelected: 'Todos seleccionados'
      },
      chartLegend: {
        next: 'Página siguiente',
        prev: 'Página anterior'
      }
    }
  }
};

export default locales;
